export const baseUrl = "https://gfg-back-end-khln.vercel.app"
// export const baseUrl = "http://localhost:5000"
export const config = {
    headers : {
        "content-type" : "application/json",
    },

    withCredentials : true,
}
